<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    isPaid: (isPaid$ | async),
    fee: (fee$ | async),
    disabled: (disabled$ | async),
    cybersourceAdditionalMsg: (cybersourceAdditionalMsg$ | async),
    isLoading: (isLoading$ | async),
    cardNumberInvalid: (cardNumberInvalid$ | async),
    cardNumberLength: (cardNumberLength$ | async),
    formAttemptedSubmit: (formAttemptedSubmit$ | async),
    securityCodeInvalid: (securityCodeInvalid$ | async),
    securityCodeTouched: (securityCodeTouched$ | async),
    expiryInvalid: (expiryInvalid$ | async)
  }"
>
</ng-container>

<ng-template
  #template
  let-isPaid="isPaid"
  let-fee="fee"
  let-disabled="disabled"
  let-cybersourceAdditionalMsg="cybersourceAdditionalMsg"
  let-isLoading="isLoading"
  let-cardNumberInvalid="cardNumberInvalid"
  let-cardNumberLength="cardNumberLength"
  let-formAttemptedSubmit="formAttemptedSubmit"
  let-securityCodeInvalid="securityCodeInvalid"
  let-securityCodeTouched="securityCodeTouched"
  let-expiryInvalid="expiryInvalid"
>
  @if (isPaid === false) {
    <div>
      <p>
        A fee of <b>{{ fee | currency }}</b> is payable. {{ cybersourceAdditionalMsg }}
      </p>
      @if (isLoading) {
        <div flexLayout="row" flexLayoutAlign="center">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      <form
        (ngSubmit)="onSubmit(form)"
        #form="ngForm"
        flexLayout="column"
        flexLayoutGap="10px"
        flexLayoutAlign="space-around"
        [ngClass]="{ isLoading: isLoading === true }"
      >
        <div
          flexLayout="row"
          flexLayout.lt-md="column"
          flexLayoutGap="10px"
          flexLayoutAlign="space-around"
        >
          <div flex="70" flex.lt-md="100">
            <label id="cardNumber-label">Card Number</label>
            <div id="number-container" class="form-control"></div>
            @if (cardNumberInvalid && ((cardNumberLength || 0) > 0 || formAttemptedSubmit)) {
              <mat-error class="microform-error">This field is required</mat-error>
            }
          </div>

          <div flex="30" flex.lt-md="100">
            <label for="securityCode-container">Security Code</label>
            <div id="securityCode-container" class="form-control"></div>
            @if (securityCodeInvalid && (securityCodeTouched || formAttemptedSubmit)) {
              <mat-error class="microform-error">This field is required</mat-error>
            }
          </div>
        </div>

        <div
          flexLayout="row"
          flexLayout.lt-md="column"
          flexLayoutGap="10px"
          flexLayoutAlign="space-around"
          flexLayoutWrap="wrap"
        >
          <mat-form-field
            flex="50"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label for="expMonth">Expiry Month</mat-label>
            <mat-select
              [disabled]="disabled"
              required
              id="expMonth"
              name="expMonth"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              ngModel
              #expMonthCtrl="ngModel"
            >
              @for (month of months; track month) {
                <mat-option [value]="month">{{ month }}</mat-option>
              }
            </mat-select>
            @if (expMonthCtrl.invalid && (expMonthCtrl.touched || formAttemptedSubmit)) {
              <mat-error> This field is required </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            flex="50"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>Expiry Year</mat-label>
            <mat-select
              [disabled]="disabled"
              required
              id="expYear"
              name="expYear"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              ngModel
              #expYearCtrl="ngModel"
            >
              @for (year of yearList; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
              }
            </mat-select>
            @if (expYearCtrl.invalid && (expYearCtrl.touched || formAttemptedSubmit)) {
              <mat-error> This field is required </mat-error>
            }
          </mat-form-field>
          @if (
            expiryInvalid && (expMonthCtrl.touched || expYearCtrl.touched || formAttemptedSubmit)
          ) {
            <div flex="100" class="expiry-error-message">
              <mat-error>Expiry date must be today or in the future</mat-error>
            </div>
          }
        </div>

        <mat-checkbox
          [ngClass]="{ cursorDisabled: disabled === true }"
          [disabled]="disabled"
          color="primary"
          id="profileCheckbox"
          name="profileCheckbox"
          (change)="populatePaymentInfo($event)"
          >Populate billing information from profile</mat-checkbox
        >

        <div
          flexLayout="row"
          flexLayout.lt-md="column"
          flexLayoutAlign="space-between"
          flexLayoutGap="10px"
        >
          <mat-form-field
            flex="50"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>First Name</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="firstName"
              name="firstName"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="firstName"
              #firstNameCtrl="ngModel"
            />
            @if (firstNameCtrl.invalid && (firstNameCtrl.touched || formAttemptedSubmit)) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field
            flex="50"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>Last Name</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="lastName"
              name="lastName"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="lastName"
              #lastNameCtrl="ngModel"
            />
            @if (lastNameCtrl.invalid && (lastNameCtrl.touched || formAttemptedSubmit)) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div
          flexLayout="row"
          flexLayout.lt-md="column"
          flexLayoutAlign="space-between"
          flexLayoutGap="10px"
        >
          <mat-form-field flex="100" [ngClass]="{ cursorDisabled: disabled === true }">
            <mat-label>Address</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="address"
              name="address"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="address"
              #addressCtrl="ngModel"
            />
            @if (addressCtrl.invalid && (addressCtrl.touched || formAttemptedSubmit)) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
        </div>

        <div
          flexLayout="row"
          flexLayout.lt-md="column"
          flexLayoutAlign="space-between"
          flexLayoutGap="10px"
        >
          <mat-form-field
            flex="25"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>City, Town, or Locality</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="locality"
              name="locality"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="locality"
              #localityCtrl="ngModel"
            />
            @if (localityCtrl.invalid && (localityCtrl.touched || formAttemptedSubmit)) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field
            flex="25"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>State, Province, or Territory</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="administrativeArea"
              name="administrativeArea"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="administrativeArea"
              #administrativeAreaCtrl="ngModel"
            />
            @if (
              administrativeAreaCtrl.invalid &&
              (administrativeAreaCtrl.touched || formAttemptedSubmit)
            ) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field
            flex="25"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label for="postalCode">Postal Code</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="postalCode"
              name="postalCode"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="postalCode"
              #postalCodeCtrl="ngModel"
            />
            @if (postalCodeCtrl.invalid && (postalCodeCtrl.touched || formAttemptedSubmit)) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field
            flex="25"
            flex.lt-md="100"
            [ngClass]="{ cursorDisabled: disabled === true }"
          >
            <mat-label>Country</mat-label>
            <input
              [disabled]="disabled"
              required
              matInput
              id="country"
              name="country"
              pattern="^[A-Za-z]{2}$"
              maxlength="2"
              minlength="2"
              [ngClass]="{
                'form-control-disabled': disabled === true,
                'form-control-enabled': disabled === false
              }"
              [(ngModel)]="country"
              #countryCtrl="ngModel"
            />
            @if (countryCtrl.invalid && (countryCtrl.touched || formAttemptedSubmit)) {
              <mat-error
                >This field is required (please use the two-letter country code without
                punctuation)</mat-error
              >
            }
            @if (countryCtrl.hasError("pattern") && (countryCtrl.touched || formAttemptedSubmit)) {
              <mat-error>Please enter a valid two-letter country code (letters only)</mat-error>
            }
          </mat-form-field>
        </div>

        <div flexLayout="row" flexLayoutAlign="end end">
          <button
            [disabled]="
              disabled ||
              isLoading ||
              form.invalid ||
              cardNumberInvalid ||
              false ||
              securityCodeInvalid ||
              false
            "
            mat-raised-button
            color="primary"
          >
            Submit Payment
          </button>
        </div>
      </form>
    </div>
  }
  <div>
    @if (isPaid) {
      <p>
        {{
          fee
            ? "Payment has been received, please proceed to submit your case."
            : "There is no charge for submitting this case."
        }}
      </p>
    }
  </div>
</ng-template>
